const translations = {
  "en": {
    "No Data Yet": "No Data Yet",
    "No data yet, but exciting updates are on the horizon!": "No data yet, but exciting updates are on the horizon!"
  },
  "zh-tw": {
    "No Data Yet": "暫無資料",
    "No data yet, but exciting updates are on the horizon!": "暫無資料，精彩更新即將上線！"
  }
};

export default translations;
